import { type FC } from 'react';

import { Outlet, useParams } from 'react-router-dom';

import { SandboxProvider } from '@/providers';

export const GameLayout: FC = () => {
  const { sandboxId } = useParams<{ sandboxId: string }>();

  return (
    <SandboxProvider initialSandbox={sandboxId}>
      <Outlet />
    </SandboxProvider>
  );
};
